window.addEventListener('openModal', event => {
    const targetModal = event.detail.targetModal;
    $('#' + targetModal).modal('show');
})
